import { render } from "./totalCount.vue?vue&type=template&id=a64a4114&scoped=true"
import script from "./totalCount.vue?vue&type=script&lang=js"
export * from "./totalCount.vue?vue&type=script&lang=js"

import "./totalCount.vue?vue&type=style&index=0&id=a64a4114&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a64a4114"]])

export default __exports__